import React from 'react'
import Subheader from '../../component/Subheader'
import FounderContent from './FounderContent'

export default function Founder() {
    const subheadData = {
      image: '../image/chairman-banner.webp',
      category: '',
      pagename: 'Founder & Legacy',
      nextItem:"",
    }

  return (
    <>
    <Subheader subheadData={subheadData}/>
     <FounderContent />
    </>
  )
}
